import { CallToBookHeader } from 'app/components/common/callToBookHeader'
import { CallToBookForm } from 'app/components/common/callToBookForm'
import { IconFooter } from 'app/components/common/iconFooter'
import React from 'react'
import PropTypes from 'prop-types'

import styles from './callToBookSection.module.scss'

const CallToBookSection = ({ location }) => {
  return (
    <div className={styles.callToBookSection}>
      <CallToBookHeader className={styles.callToBookHeader__header} />
      <CallToBookForm className={styles.callToBookForm} />
      <IconFooter className={`${styles.iconFooter}`} semiBold location={location} />
    </div>
  )
}

CallToBookSection.propTypes = {
  onConfirm: PropTypes.func,
}

export { CallToBookSection }
